

// src/fontAwesome.js
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebook, faGithub, faLinkedin, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faHome, faComment, faPhone, faSignInAlt, faUserPlus, faSignOutAlt, faMoon, faSun, faArrowUp } from '@fortawesome/free-solid-svg-icons';

library.add(faFacebook, faGithub, faLinkedin, faInstagram, faEnvelope, faHome, faComment, faPhone, faSignInAlt, faUserPlus, faSignOutAlt, faMoon, faSun, faArrowUp);
